import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-angular-six-sided',
  templateUrl: './curtain-angular-six-sided.component.html',
  styleUrls: ['./curtain-angular-six-sided.component.scss']
})
export class CurtainAngularSixSidedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
